import { useMemo } from 'react'

import { CommonPropsTeam, TeamActionsTypes } from './types'
import { modalsActions } from './utils'

type Props = {
  type: TeamActionsTypes
} & CommonPropsTeam

export const TeamsActions = ({ type, ...props }: Props) => {
  const Component = useMemo(() => modalsActions[type], [type])

  if (!Component) return null

  return <Component {...props} />
}
